export const createSlug = (text) => {
  if (!text) return "";

  return text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')      // Replace spaces with hyphens
    .replace(/-+/g, '-')       // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '');  // Remove leading/trailing hyphens
};

//   return String(text)                     // force string
//     .normalize("NFD")                     // handle accents
//     .replace(/[\u0300-\u036f]/g, "")      // strip diacritics
//     .toLowerCase()
//     .replace(/[^a-z0-9]+/g, "-")
//     .replace(/-+/g, "-")
//     .replace(/^-+|-+$/g, "");
// };

export const formatDateTime = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleString('ta-IN', {
    day: '2-digit', month: 'long', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
  });
};

/* Format date as "21/9/2025 9:32 AM" matching Tamil reading style */
export const formatDate = (iso) =>{
  const d = new Date(iso);
  return d.toLocaleString('ta-IN', {
    day: 'numeric', month: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
  });
};

export const formatDateOnly = (date) =>
  new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(date));

export const formatDateTime1 = (dateString) => {

  if (!dateString) return;
  const date = new Date(dateString);
  if (isNaN(date)) return;

  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(date);
};

export const formatDescription = (text) => {
  if (!text) return null;

  return text
    .split('<br />')
    .filter(para => {
      const cleanPara = para.replace(/<br\s*\/?>/gi, '').trim();
      return cleanPara.length > 0;
    })
    .map((para, index) => (
      <p
        key={index}
        className="mb-3"
        style={{
          textAlign: 'justify',
          lineHeight: '1.8',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
        dangerouslySetInnerHTML={{ __html: para }}
      />
    ));
};
